<umkt-auth-layout scrollable>
  <div class="auth-back">
    <a (click)="openLogoutConfirm()" style="cursor: pointer;">
      {{ 'pages.registerMovel.logout' | i18n }}
      <mat-icon class="logout-icon" style="margin-left: 8px;">logout</mat-icon>
    </a>
  </div>

  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title">
          <h1 class="title-text font-highlight">
            {{ 'pages.registerMovel.title' | i18n }}
          </h1>
          <p class="subtitle-text">
            {{ 'pages.registerMovel.subtitle' | i18n }}
          </p>
        </div>

        <!-- Search Bar -->
        <div class="search-container">
          <div class="search-input-wrapper">
            <mat-icon class="search-icon">search</mat-icon>
            <input 
              type="text" 
              [placeholder]="'pages.registerMovel.searchPlaceholder' | i18n"
              [(ngModel)]="searchTerm"
              (input)="onSearchChange($event)"
              (keypress)="onKeyPress($event)"
              class="search-input"
              #searchInput
            >
            <mat-icon 
              *ngIf="searchTerm" 
              class="clear-icon" 
              (click)="clearSearch()"
              style="cursor: pointer;"
            >close</mat-icon>
          </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="loading-container">
          <svg class="loading-spinner" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
            <g transform="translate(8, 0)"> 
              <path d="M8 19c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.345 3 3-1.345 3-3 3zm0-8C5.243 11 3 13.243 3 16s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z"></path>
              <g id="loading-blades">
                <path d="M19.182 6.232L14.233 11.182 12.818 9.767 17.768 4.817z"></path>
                <path d="M15 17h6v-2h-6z"></path>
                <path d="M7 9h2V3H7z"></path>
              </g>
            </g>
          </svg>
          <p class="loading-text">{{ 'pages.registerMovel.loading' | i18n }}</p>
        </div>

        <!-- CNPJ List -->
        <div *ngIf="!loading" class="cnpj-list" [class.scrollable]="hasMoreThanFourItems">
          <div 
            *ngFor="let cnpj of filteredCnpjAccounts; trackBy: trackByCnpj"
            class="cnpj-option"
            [class.selected]="selectedCnpj?.cnpj === cnpj.cnpj"
            (click)="selectCnpj(cnpj)"
          >
            <div class="cnpj-icon">
              <mat-icon class="business-icon">business</mat-icon>
            </div>
            <div class="cnpj-info">
              <div class="cnpj-number">
                {{ cnpj.cnpj }}
              </div>
              <div class="company-name">
                {{ cnpj.companyName }}
              </div>
            </div>
            <div class="cnpj-arrow">
              <mat-icon class="arrow-icon">chevron_right</mat-icon>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="!loading && filteredCnpjAccounts.length === 0" class="empty-state">
          <mat-icon class="empty-icon">business_center</mat-icon>
          <p class="empty-text">{{ 'pages.registerMovel.empty.title' | i18n }}</p>
          <p class="empty-subtext">{{ 'pages.registerMovel.empty.subtitle' | i18n }}</p>
        </div>

        <!-- Help Section -->
        <div class="help-section">
          <p class="help-text">
            <strong>{{ 'pages.registerMovel.help.title' | i18n }}</strong>
          </p>
          <p>
            {{ 'pages.registerMovel.help.description' | i18n }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <umkt-confirm-modal
    [open]="showLogoutConfirm"
    variant="danger"
    icon="bi bi-exclamation-triangle"
    [title]="'pages.registerMovel.logoutModal.title' | i18n"
    [message]="'pages.registerMovel.logoutModal.message' | i18n"
    (confirm)="handleLogoutConfirm()"
    (canceled)="handleLogoutCancel()"
    (closed)="handleLogoutCancel()"
    [confirmText]="'pages.registerMovel.logoutModal.confirm' | i18n"
    [cancelText]="'shared.buttons.cancel' | i18n"
  ></umkt-confirm-modal>
</umkt-auth-layout>